const allowedRoles = [
  "admin",
  "ai_animation_admin",
  "ai_animation_view",
  "ai_animation_create",
  "ai_image_view",
];

const createRoles = ["admin", "ai_animation_admin", "ai_animation_create"];

const deleteRoles = ["admin", "ai_animation_admin"];

const AIAnimationService = {
  allowedRoles,
  createRoles,
  deleteRoles,
};

export default AIAnimationService;
